export default __webpack_public_path__ + "static/thumbnail-77b9e8f308c7f4875d53bf248f8abfbc.png";